<div [class.relative]="showArrows()">
  <div
    #track
    [class]="
      'flex snap-x snap-mandatory overflow-x-auto scroll-smooth [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ' +
      trackClass()
    "
    (scroll)="onScroll($event)"
  >
    <ng-content />
  </div>
  @if (showArrows() && count() > 1) {
    <button
      type="button"
      class="cursor-pointer absolute left-3 top-1/2 z-10 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-line bg-white/90 text-ink shadow-sm transition hover:scale-105 md:flex"
      aria-label="Previous"
      (click)="prev()"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.75"
        class="h-5 w-5"
        aria-hidden="true"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
      </svg>
    </button>
    <button
      type="button"
      class="cursor-pointer absolute right-3 top-1/2 z-10 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-line bg-white/90 text-ink shadow-sm transition hover:scale-105 md:flex"
      aria-label="Next"
      (click)="next()"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.75"
        class="h-5 w-5"
        aria-hidden="true"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
      </svg>
    </button>
  }
</div>
@if (count() > 1) {
  <div
    [class]="'flex justify-center gap-2 ' + dotsClass()"
    role="tablist"
    [attr.aria-label]="ariaLabel()"
  >
    @for (i of indices(); track i) {
      <button
        type="button"
        role="tab"
        class="cursor-pointer h-2 w-2 rounded-full transition-colors"
        [class.bg-forest]="active() === i"
        [class.bg-ink/25]="active() !== i"
        [attr.aria-selected]="active() === i"
        [attr.aria-label]="dotLabel() + ' ' + (i + 1)"
        (click)="goTo(i)"
      ></button>
    }
  </div>
}
